﻿import { WorkTrayView } from 'runtime/data/worktrayview';
import { ValidationSummary } from 'shared/data/validation';

export class ViewSaveRequested {
    constructor(public view: WorkTrayView, public isNew: boolean, public completionAction: () => void, public validationFailed: (x: ValidationSummary) => void) {}

    static eventName() { return 'ViewSaveRequested'; }

    eventName = ViewSaveRequested.eventName;
}